// ABOUTME: Confirmation dialog for child deletion with warning message
// ABOUTME: Shows permanent deletion warning and loading state during operation

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';
import type { ChildDetail } from '../types';

interface DeleteChildDialogProps {
  open: boolean;
  child: ChildDetail | null;
  deleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteChildDialog: React.FC<DeleteChildDialogProps> = ({
  open,
  child,
  deleting,
  onClose,
  onConfirm
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !deleting && onClose()}
    >
      <DialogTitle>Delete Child?</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete <strong>{child?.name}</strong>?
        </Typography>
        <Typography sx={{ mt: 2, color: 'error.main' }}>
          Warning: This action cannot be undone. All behavior records and data for this child will be permanently deleted.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={deleting}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={deleting}
        >
          {deleting ? <CircularProgress size={20} /> : 'Delete Child'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteChildDialog;
